import styled from "styled-components";
import { useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import CustomButton from "../../../helperComponents/CustomButton";
import MiniProfileCard from "../MiniProfileCard";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import PermissionGuard from "../../../customUiForCs/PermissionGuard";
import AddOrEditVacationModular from "./AddOrEditVacationModular";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 35vw;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  border-radius: 20px;
  background-color: var(--surface2);
  border: 1px solid var(--border);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 15px;
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

let dropDownStyle = { flex: 1 };

export default function AddOrEditVacation({}) {
  const [itemID, setItemID] = useState(null);
  const [userID, setUserID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("ADD");

  useEffect(() => {
    let newItemID = getUrlQuery("itemID");
    setItemID(newItemID);

    setUserID(getUrlQuery("userID"));

    if (newItemID) setPurpose("UPDATE");
  }, []);

  let titleLine1 = "Ajouter";
  let titleLine2 = "des vacances";

  if (purpose == "UPDATE") {
    titleLine1 = "Modifier";
    titleLine2 = "les vacances";
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      <br />
      <br />
      <br />
      <br />
      <br />
      <AddOrEditVacationModular
        itemID={itemID}
        userID={userID}
        purpose={purpose}
        loading={loading}
        setLoading={setLoading}
        callback={callback}
      />
    </LoggedInBoilerplate>
  );

  function callback(newItem) {
    if (purpose == "UPDATE") goTo(`/employee/${newItem.userID}`)();
    if (purpose == "ADD") goTo(`/employee/${userID}`)();
  }
}
